export default "__VITE_ASSET__C9STpJ9v__"